// src/js/main.js
import $ from 'jquery';
window.jQuery = $; window.$ = $; // Make it available globally if needed by other scripts
// ... other imports

import '../scss/main.scss';
import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';
import Dropdown from 'bootstrap/js/dist/dropdown';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './background-video';
import './navbar';
import './mobile-menu';
import './sidebars';
import './searchbar-header';
import './sidebar-inner';
import './sticky-nav';
import './swiper';
import './program-listing';
import './directory-listing';

// Since the files are within the slick subdirectory, adjust the paths accordingly
import '@accessible360/accessible-slick/slick/slick.scss';
import '@accessible360/accessible-slick/slick/slick-theme.scss'; // Optional, for default theme
